import React, {useEffect, useState} from "react";
import axios from "axios";
import {API_URL, PUSHER_KEY} from "../../../config";
import {useSnackbar} from "../../../context/SnackbarContext/SnackbarContext";
import {useSelector} from "react-redux";
import MDBox from "../../../components/MDBox";
import DefaultItem from "../../../components/Items/DefaultItem";
import MDTypography from "../../../components/MDTypography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import PlayerSeat from "./components/PlayerSeat/PlayerSeat";
import assignForm from "./schemas/assign/form";
import assignValidations from "./schemas/assign/validations";
import doneForm from "./schemas/done/form";
import doneValidations from "./schemas/done/validations";
import editForm from "./schemas/edit/form";
import editValidations from "./schemas/edit/validations";
import addTimeToAllForm from "./schemas/addTimeToAll/form";
import addTimeToAllValidations from "./schemas/addTimeToAll/validations";
import Pusher from "pusher-js";
import MDButton from "../../../components/MDButton";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from '@mui/icons-material/Visibility';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import AddAlarmIcon from '@mui/icons-material/AddAlarm';
import {useNavigate} from "react-router-dom";

const useLobby = () => {

    let navigate = useNavigate();

    const {formId: assignFormId, formField: assignFormField} = assignForm;
    const assignCurrentValidation = assignValidations;

    const [assignModalOpen, setAssignModalOpen] = React.useState(false);
    const handleAssignClose = () => setAssignModalOpen(false);

    const {formId: doneFormId, formField: doneFormField} = doneForm;
    const doneCurrentValidation = doneValidations;

    const [doneModalOpen, setDoneModalOpen] = React.useState(false);
    const handleDoneClose = () => setDoneModalOpen(false);

    const {formId: editFormId, formField: editFormField} = editForm;
    const editCurrentValidation = editValidations;

    const [editModalOpen, setEditModalOpen] = React.useState(false);
    const handleEditClose = () => setEditModalOpen(false);

    const sessionState = useSelector((state) => state.sessionReducer);

    const {showSnackbar} = useSnackbar();

    const [isLoading, setIsLoading] = useState(true);

    // const [seatCost, setSeatCost] = useState(0);

    const [sessionMembers, setSessionMembers] = useState([]);
    const [tables, setTables] = useState([]);

    const [selectedMemberSession, setSelectedMemberSession] = useState(null);
    const [selectedSeat, setSelectedSeat] = useState(null);
    const [selectedTable, setSelectedTable] = useState(null);
    const [selectedPlayer, setSelectedPlayer] = useState(null);

    const [isMoving, setIsMoving] = useState(false);

    const [unpauseDialogOpen, setUnpauseDialogOpen] = useState(false);
    const [selectedTableForUnpause, setSelectedTableForUnpause] = useState(null);

    const {formId: addTimeForAllFormId, formField: addTimeForAllFormField} = addTimeToAllForm;
    const [addTimeDialogOpen, setAddTimeDialogOpen] = useState(false);
    const [selectedTableForAddTime, setSelectedTableForAddTime] = useState(null);

    const [earningsDialogOpen, setEarningsDialogOpen] = React.useState(false);
    const [currentEarnings, setCurrentEarnings] = React.useState(0);

    useEffect(() => {

        const init = async () => {
            setIsLoading(true);
            // await loadSettings();
            await loadSession();
            await loadSessionMembers();
            await loadTables();
            setIsLoading(false);
        };

        init();

        // Enable pusher logging - don't include this in production
        Pusher.logToConsole = true;

        const pusher = new Pusher(PUSHER_KEY, {
            cluster: 'us2'
        });

        const channel = pusher.subscribe('member_sessions');
        channel.bind('member_session_updated', function (data) {
            updateMemberSession(data.memberSession);
        });

    }, []);

    const updateMemberSession = (memberSession) => {

        setSessionMembers(prevSessionMembers => {
            let currentIndex = prevSessionMembers.findIndex(sessionMember => sessionMember.id === memberSession.id);

            let newSessionMembers = [...prevSessionMembers];

            if (currentIndex === -1) {

                newSessionMembers.push(memberSession);

                // If the memberSession is not found, you may choose to return prevSessionMembers unmodified, or add the memberSession to the array.
                return newSessionMembers;
            }

            newSessionMembers[currentIndex] = memberSession;

            return newSessionMembers;
        });

    };

    const loadSession = async () => {
        try {

            const response = await axios.get(`${API_URL}/sessions/current`);

            setCurrentEarnings(response.data.extra_earnings);

        } catch (error) {

            showSnackbar('Settings', 'Something went wrong loading the app settings', 'cancel', 'warning');

        }
    };

    const handleUnpauseDialogOpen = (table) => {
        setSelectedTableForUnpause(table);
        setUnpauseDialogOpen(true);
    };

    const handleUnpauseDialogClose = () => {
        setUnpauseDialogOpen(false);
        setSelectedTableForUnpause(null);
    };

    const handleAddTimeDialogOpen = (table) => {
        console.log(sessionMembers);
        setSelectedTableForAddTime(table);
        setAddTimeDialogOpen(true);
    };

    const handleAddTimeDialogClose = () => {
        setAddTimeDialogOpen(false);
        setSelectedTableForAddTime(null);
    };

    const handleEarningsDialogOpen = () => {
        setEarningsDialogOpen(true);
    };

    const handleEarningsDialogClose = () => {
        setEarningsDialogOpen(false);
    };

    const handleEarningsDialogSubmit = async (values) => {

        try {

            // Enviar datos a API
            const response = await axios.put(
                `${API_URL}/sessions/extra`,
                {extra_earnings: values.amount}
            );


            showSnackbar('Lobby', 'Extra earnings saved', 'notifications', 'success');

            setCurrentEarnings(response.data.extra_earnings);
            setEarningsDialogOpen(false);

        } catch (error) {

            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

        }
    };

    const loadSessionMembers = async () => {

        try {

            const response = await axios.get(`${API_URL}/session/members`, {
                params: {
                    sort: 'arrived_at',
                    direction: 'asc'
                }
            });

            if (response.data.length > 0)
                setSessionMembers(response.data);

        } catch (error) {

            showSnackbar('Session Members', 'Something went wrong loading the session members', 'cancel', 'warning');

        }

    };

    const loadTables = async () => {

        try {

            const response = await axios.get(`${API_URL}/tables`, {
                params: {
                    sort: 'id',
                    direction: 'asc',
                    active: true
                }
            });

            if (response.data.length > 0)
                setTables(response.data);

        } catch (error) {

            showSnackbar('Tables', 'Something went wrong loading the tables', 'cancel', 'warning');

        }

    };

    const handleMove = async (sessionMemberId, seatId) => {

        try {

            let data = {};

            data.seat_id = seatId;
            data.is_moving = true;

            // Enviar datos a API
            await axios.put(
                `${API_URL}/session/members/${sessionMemberId}`,
                {...data}
            );

            setSelectedMemberSession(null);
            setSelectedSeat(null);
            setIsMoving(false);

            showSnackbar('Lobby', 'Member successfully seated', 'notifications', 'success');

        } catch (error) {

            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

        }
    };

    const handleAssign = async (values, actions) => {

        try {

            let data = {...values};

            data.seat_id = selectedSeat;

            // Enviar datos a API
            await axios.put(
                `${API_URL}/session/members/${selectedMemberSession}`,
                {...data}
            );

            actions.resetForm();
            setSelectedMemberSession(null);
            setSelectedSeat(null);
            setAssignModalOpen(false);

            showSnackbar('Lobby', 'Member successfully seated', 'notifications', 'success');

        } catch (error) {

            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

        }

        actions.setSubmitting(false);
    };

    const handleDone = async (player) => {

        try {

            // Enviar datos a API
            await axios.put(
                `${API_URL}/session/members/${player}/done`
            );

            showSnackbar('Lobby', 'Member successfully updated', 'notifications', 'success');

        } catch (error) {

            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

        }
    };

    const handleAddTimeToAll = async (values, actions) => {
        try {

            // Extract relevant data from values
            const { hours, is_free, is_late_night, players } = values;

            // Prepare the payload for the API
            const data = {
                hours,
                is_free,
                is_late_night,
            };

            // Perform API requests for each player in the values.players array
            for (const playerId of players) {
                await axios.put(
                    `${API_URL}/session/members/${playerId}/add`, // Use the player ID in the API URL
                    { ...data } // Pass hours, is_free, and is_late_night for each player
                );
            }

            actions.resetForm();
            setAddTimeDialogOpen(false);

            showSnackbar('Lobby', 'Time successfully added to all selected players', 'notifications', 'success');

        } catch (error) {

            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

        }

        actions.setSubmitting(false);
    };

    const handleStart = async (id) => {

        try {

            // Enviar datos a API
            await axios.put(
                `${API_URL}/session/members/${id}/start`
            );

        } catch (error) {

            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

        }
    };

    const handleStartAll = async (table) => {
        try {
            const response = await axios.put(
                `${API_URL}/session/tables/${table.id}/timers/start`
            );

            response.data.member_sessions.forEach(updateMemberSession);

            showSnackbar(
                'Lobby',
                `${response.data.started_count} player timer${response.data.started_count === 1 ? '' : 's'} started`,
                'notifications',
                'success'
            );
        } catch (error) {
            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');
        }
    };

    const handlePauseAll = async (table) => {
        const seatIds = new Set(table.seats.map((seat) => seat.id));
        const runningPlayers = sessionMembers.filter((sessionMember) => (
            sessionMember.status === 'playing'
            && sessionMember.finished_at !== null
            && sessionMember.paused_at === null
            && seatIds.has(sessionMember.seat_id)
        ));

        await Promise.all(runningPlayers.map(async (seatPlayer) => {
                try {

                    // Enviar datos a API
                    await axios.put(
                        `${API_URL}/session/members/${seatPlayer.id}/pause`
                    );

                } catch (error) {

                    showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

                }
        }));
    };

    const handleUnpauseAll = async (table) => {
        table.seats.map(async (seat) => {
            let seatPlayer = sessionMembers
                .filter((sessionMember) => sessionMember.paused_at !== null && sessionMember.status === 'playing')
                .find((sessionMember) => sessionMember.seat_id === seat.id);

            if (seatPlayer) {
                try {
                    // Call the API to unpause this member
                    await axios.put(`${API_URL}/session/members/${seatPlayer.id}/unpause`);
                } catch (error) {
                    showSnackbar("Lobby", error.response.data.message, "cancel", "warning");
                }
            }
        });
    };

    const handlePause = async (id) => {

        try {

            // Enviar datos a API
            await axios.put(
                `${API_URL}/session/members/${id}/pause`
            );

        } catch (error) {

            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

        }
    };

    const handleUnpause = async (id) => {

        try {

            // Enviar datos a API
            await axios.put(
                `${API_URL}/session/members/${id}/unpause`
            );

        } catch (error) {

            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

        }
    };

    const handleEdit = async (values, actions) => {

        try {

            let data = {...values};

            // Enviar datos a API
            await axios.put(
                `${API_URL}/session/members/${selectedPlayer}/add`,
                {...data}
            );

            actions.resetForm();
            setSelectedPlayer(null);
            setEditModalOpen(false);

            showSnackbar('Lobby', 'Member successfully updated', 'notifications', 'success');

        } catch (error) {

            showSnackbar('Lobby', error.response.data.message, 'cancel', 'warning');

        }

        actions.setSubmitting(false);
    };

    const handleSeatSelect = (seatId, table) => {
        setSelectedSeat(seatId);
        setSelectedTable(table);

        if(isMoving){
            handleMove(selectedMemberSession, seatId);

        } else {
            setAssignModalOpen(true);
        }
    };

    const handleDoneSelect = async (sessionMemberId, table) => {
        setSelectedTable(table);
        await handleDone(sessionMemberId)
    };

    const handleEditSelect = (sessionMemberId, table) => {
        setSelectedPlayer(sessionMemberId);
        setSelectedTable(table);
        setEditModalOpen(true);
    };

    const handleMoveSelect = (sessionMemberId) => {
        setSelectedMemberSession(sessionMemberId);
        setIsMoving(true);
    };

    const getSeatCost = () => {
        const now = new Date();
        const hour = now.getHours();

        let isBetween1AMAnd6AM = hour >= 1 && hour <= 6;

        if(isBetween1AMAnd6AM)
            return selectedTable.late_seat_cost;
        else
            return selectedTable.seat_cost;
    }

    const renderMembersList = () => {
        return sessionMembers.filter(memberSession => memberSession.status === 'waiting').map(memberSession => (
            <MDBox px={1} mb={1}>
                <MDBox>
                    <DefaultItem
                        handleItemClick={() => setSelectedMemberSession(memberSession.id)}
                        selected={selectedMemberSession === memberSession.id}
                        color="dark"
                        icon="savings"
                        title={memberSession.member.name}
                        description={memberSession.arrived_at}
                    />
                </MDBox>
            </MDBox>
        ))
    };

    const renderTableSeats = (table) => {
        return table.seats.map((seat, index) => {

            let seatPlayer = sessionMembers.filter(sessionMember => sessionMember.status === 'playing').find(sessionMember => sessionMember.seat_id === seat.id);

            return <PlayerSeat
                key={seat.id}
                onSelect={() => handleSeatSelect(seat.id, table)}
                selectable={selectedMemberSession !== null && !seatPlayer}
                seat={seat}
                player={seatPlayer}
                handleDone={() => handleDoneSelect(seatPlayer.id, table)}
                handleEdit={() => handleEditSelect(seatPlayer.id, table)}
                handleMove={() => handleMoveSelect(seatPlayer.id)}
                handleStart={() => handleStart(seatPlayer.id)}
                handlePause={() => handlePause(seatPlayer.id)}
                handleUnpause={() => handleUnpause(seatPlayer.id)}
            />
        })
    };

    const renderTables = () => {

        return tables.map(table => {

            // Check the seats and their members' statuses for this table
            const seatPlayingLookup = (seatId) => (
                sessionMembers
                    .filter((member) => member.status === 'playing')
                    .find((member) => member.seat_id === seatId)
            );

            const playingMembers = table.seats.filter((seat) => {
                const seatPlayer = seatPlayingLookup(seat.id);
                return !!seatPlayer && seatPlayer.finished_at !== null && seatPlayer.paused_at === null;
            });

            const pausedMembers = table.seats.filter((seat) => {
                const seatPlayer = seatPlayingLookup(seat.id);
                return !!seatPlayer && seatPlayer.finished_at !== null && seatPlayer.paused_at !== null;
            });

            const startableMembers = table.seats.filter((seat) => {
                const seatPlayer = seatPlayingLookup(seat.id);
                return !!seatPlayer
                    && seatPlayer.started_at === null
                    && seatPlayer.finished_at === null
                    && seatPlayer.paused_at === null
                    && seatPlayer.available_hours !== null
                    && seatPlayer.available_hours > 0;
            });

            // Determine whether to show "Pause" or "Unpause" button
            const showPauseButton = playingMembers.length > 0;
            const showUnpauseButton = pausedMembers.length > 0 && playingMembers.length === 0;

            const showAddTimeButton = playingMembers.length > 0 || pausedMembers.length > 0;
            const showStartAllButton = startableMembers.length > 0;

            return <Grid key={table.id} item sx={{minWidth: '25%'}}>
                <MDBox p={2} lineHeight={1}
                       sx={{borderWidth: 1, borderStyle: 'solid', borderRadius: 4, maxHeight: '85vh', overflowY: 'scroll'}}>
                    <MDBox
                        sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start'}}>
                        <MDBox sx={{flexGrow: 1}}>
                            <MDTypography variant="h6" fontWeight="medium">
                                {table.name}
                            </MDTypography>
                        </MDBox>
                        {showStartAllButton && (
                            <Tooltip title="Start all timers" placement="top" arrow>
                                <IconButton
                                    aria-label={`Start all timers for ${table.name}`}
                                    color="white"
                                    onClick={() => handleStartAll(table)}
                                >
                                    <PlayCircleOutlineIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                        {
                            showAddTimeButton && (
                                <Tooltip title="Add time to players" placement="top" arrow>
                                    <IconButton
                                        aria-label={`Add time for players at ${table.name}`}
                                        color="white"
                                        onClick={() => handleAddTimeDialogOpen(table)}
                                    >
                                        <AddAlarmIcon />
                                    </IconButton>
                                </Tooltip>
                            )
                        }
                        {showPauseButton && (
                            <Tooltip title="Pause all timers" placement="top" arrow>
                                <IconButton
                                    aria-label={`Pause all timers for ${table.name}`}
                                    color="white"
                                    onClick={() => handlePauseAll(table)}
                                >
                                    <PauseIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                        {showUnpauseButton && (
                            <Tooltip title="Resume all timers" placement="top" arrow>
                                <IconButton
                                    aria-label={`Resume all timers for ${table.name}`}
                                    color="white"
                                    onClick={() => handleUnpauseDialogOpen(table)}
                                >
                                    <PlayArrowIcon>play_arrow</PlayArrowIcon>
                                </IconButton>
                            </Tooltip>
                        )}
                        <Tooltip title="View players" placement="top" arrow>
                            <IconButton
                                aria-label={`View players for ${table.name}`}
                                color="white"
                                onClick={() => navigate(`/tables/${table.id}/players`)}
                            >
                                <VisibilityIcon />
                            </IconButton>
                        </Tooltip>
                    </MDBox>
                    <Divider/>
                    {
                        renderTableSeats(table)
                    }
                </MDBox>
            </Grid>
        })
    };

    const getPlayingMembersForTable = (table) => {
        return table.seats.map((seat) => {
            return sessionMembers.find(
                (member) => member.seat_id === seat.id && member.status === "playing"
            );
        }).filter(Boolean); // Remove `undefined` values if no member found for a seat
    };

    return {
        assignCurrentValidation,
        assignFormId,
        assignFormField,
        doneCurrentValidation,
        doneFormId,
        doneFormField,
        editCurrentValidation,
        editFormId,
        editFormField,
        isLoading,
        sessionMembers,
        sessionState,
        tables,
        assignModalOpen,
        doneModalOpen,
        editModalOpen,
        selectedTable,
        handleAssignClose,
        handleDoneClose,
        handleEditClose,
        renderMembersList,
        getSeatCost,
        renderTables,
        handleAssign,
        handleDone,
        handleEdit,
        unpauseDialogOpen,
        handleUnpauseDialogOpen,
        handleUnpauseDialogClose,
        selectedTableForUnpause,
        handleUnpauseAll,
        handleAddTimeDialogOpen,
        handleAddTimeDialogClose,
        handleAddTimeToAll,
        addTimeDialogOpen,
        selectedTableForAddTime,
        addTimeToAllForm,
        addTimeForAllFormField,
        addTimeForAllFormId,
        addTimeToAllValidations,
        getPlayingMembersForTable,
        earningsDialogOpen,
        currentEarnings,
        handleEarningsDialogClose,
        handleEarningsDialogSubmit,
        handleEarningsDialogOpen
    };
};

export default useLobby;
